module.exports = __webpack_public_path__ + "img/chara_line_6.46111d22.png";